export default ['Agoda', 'APItude', 'DOTW', 'EPS', 'FIT', 'HMSAirAsia', 'MGJarvis']
